export default "__VITE_ASSET__BUt$p5Yb__"